import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { HeaderSubtitle as Subtitle } from '@src/components/ui';

import { getPlatformFromNewDash } from './helpers';

export const HeaderTitle = (props) => {
    const {
        as: As = 'h1',
        title,
        subTitle,
        couldContainNewKeyWord = false,
    } = props;

    return (
        <Row id="header-title" className="global-header-title">
            <Col className="text-center">
                <As>
                    {
                        couldContainNewKeyWord
                        && getPlatformFromNewDash({ title })
                    }
                    {
                        !couldContainNewKeyWord
                        && title
                    }
                </As>
                {subTitle && <Subtitle>{subTitle}</Subtitle>}
            </Col>

        </Row>
    );
};

HeaderTitle.propTypes = {
    as: PropTypes.string,
    title: PropTypes.string,
    subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.node]),

    couldContainNewKeyWord: PropTypes.bool,
};

export default HeaderTitle;
